<template>
  <div class="flex-column h100">
    <navbar title="衣物查询"></navbar>
    <div class="clothingInquiries flex1 flex-column h100">
      <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="衣物操作" name="first">
            <div class="inblock">
              <span>衣物编号或订单 :</span>
              <el-input
                class="mr10 ml10"
                v-model="order"
                placeholder="请输入内容"
                @keyup.enter.native="queryOrder()"
              ></el-input>
              <el-button type="primary" @click="queryOrder">查询</el-button>
              <el-button type="primary">打印</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="mt10">
        <el-card class="box-card Exhibition">
          <div slot="header" class="clearfix">
            <span>订单详情</span>
          </div>
          <div class="body_content">
            <span>
              <i>订单编号:</i>
              {{orderInfo.shop_order_no}}
            </span>
            <span>
              <i>订单金额:</i>
              {{orderInfo.order_total_price}}元
            </span>
            <span>
              <i>实收金额:</i>
              {{orderInfo.total_price}}元
            </span>
            <br />
            <span>
              <i>收衣门店:</i>
              {{orderInfo.shopName}}
            </span>
            <span>
              <i>店员姓名:</i>
              {{orderInfo.name}}
            </span>
            <span>
              <i>联系电话:</i>
              {{orderInfo.mobile}}
            </span>
            <span>
              <i>详细地址:</i>
              {{orderInfo.user_address}}
            </span>
            <br />
            <span>
              <i>客户姓名:</i>
              {{orderInfo.username}}
            </span>
            <span>
              <i>联系电话:</i>
              {{orderInfo.telnum}}
            </span>
            <span>
              <i>衣服件数:</i>
              {{orderInfo.total_count}}件
            </span>
            <span>
              <i>收衣时间:</i>
              {{orderInfo.create_time}}
            </span>
          </div>
        </el-card>
      </div>
      <div class="flex1 mt10 flex-column h100">
        <div class="flex1">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>衣物信息</span>
            </div>
            <div>
              <el-table
                :height="250"
                :data="orderInfo.cloth"
                border
                style="width: 100%"
                :row-class-name="tableRowClassName"
                @cell-dblclick="tableDbEdit"
              >
                <el-table-column prop="shop_order_no" label="订单号" sortable></el-table-column>
                <el-table-column prop="code_num" label="条形码"></el-table-column>
                <el-table-column prop="name" label="衣物名称"></el-table-column>
                <el-table-column prop="brand" label="品牌"></el-table-column>
                <el-table-column prop="color" label="颜色"></el-table-column>
                <el-table-column prop="cloth_wg" label="网格"></el-table-column>
                <el-table-column prop="price" label="价格"></el-table-column>
                <el-table-column prop="wash_remark" label="洗涤方式、附加服务、附加费"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="appendix" label="附件"></el-table-column>
                <el-table-column prop="cloth_status" label="衣物状态"></el-table-column>
                <el-table-column prop="hang_num" label="挂衣点"></el-table-column>
                <el-table-column prop="is_return" label="返洗"></el-table-column>
                <el-table-column prop="create_time" label="时间" sortable></el-table-column>
              </el-table>
            </div>
          </el-card>
        </div>
        <div class="flex1 flex mt10">
          <div class="flex1">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>资金记录</span>
              </div>
              <div>
                <el-table
                  :height="250"
                  :data="orderInfo.moneyInfo"
                  border
                  style="width: 100%"
                  :row-class-name="tableRowClassName"
                >
                  <el-table-column prop="money" label="交易金额" width="180"></el-table-column>
                  <el-table-column prop="pay_type" label="支付方式" width="180"></el-table-column>
                  <el-table-column prop="scen" label="交易类型"></el-table-column>
                  <el-table-column prop="remark" label="备注"></el-table-column>
                  <el-table-column prop="create_time" label="时间" sortable></el-table-column>
                </el-table>
              </div>
            </el-card>
          </div>
          <div class="flex1 ml10">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>工厂操作记录</span>
              </div>
              <div>
                <el-table
                  :height="250"
                  :data="orderInfo.factoryRecord"
                  border
                  style="width: 100%"
                  :row-class-name="tableRowClassName"
                >
                  <el-table-column prop="code_num" label="条形码" width="180"></el-table-column>
                  <el-table-column prop="factory_position_id" label="工序" width="180"></el-table-column>
                  <el-table-column prop="factory_member_name" label="员工"></el-table-column>
                  <el-table-column prop="create_time" label="操作时间" sortable></el-table-column>
                </el-table>
              </div>
            </el-card>
          </div>
        </div>
        <div class="flex1 flex mt10 mb30">
          <div class="flex1">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>门店操作</span>
              </div>
              <div>
                <el-table
                  :height="250"
                  :data="orderInfo.shopRecord"
                  border
                  style="width: 100%"
                  :row-class-name="tableRowClassName"
                >
                  <el-table-column prop="code_num" label="条形码" width="180"></el-table-column>
                  <el-table-column prop="factory_position_id" label="状态" width="180"></el-table-column>
                  <el-table-column prop="remark" label="备注信息"></el-table-column>
                  <el-table-column prop="shopName" label="门店"></el-table-column>
                  <el-table-column prop="create_time" label="时间" sortable></el-table-column>
                </el-table>
              </div>
            </el-card>
          </div>
          <div class="flex1 ml10">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>误扫码操作记录</span>
              </div>
              <div>
                <el-table
                  :height="250"
                  :data="tableData"
                  border
                  style="width: 100%"
                  :row-class-name="tableRowClassName"
                >
                  <el-table-column prop="date" label="条形码" width="180"></el-table-column>
                  <el-table-column prop="name" label="工序" width="180"></el-table-column>
                  <el-table-column prop="address" label="员工"></el-table-column>
                  <el-table-column prop="address" label="门店"></el-table-column>
                  <el-table-column prop="date" label="操作时间" sortable></el-table-column>
                </el-table>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import header from '@/components/header'
export default {
  components: {
    navbar: header
  },
  data() {
    return {
      activeName: 'first',
      order: '',
      orderInfo: {
        cloth: [],
        moneyInfo: [],
        factoryRecord: [],
        shopRecord: []
      },
      tableData: []
    }
  },
  methods: {
    async tableDbEdit(row) {
      if (row['code_num']) {
        let res = await this.$http.orderAbout(row['code_num'])
        this.orderInfo.factoryRecord = res.data.data.factory_record
        this.orderInfo.shopRecord = res.data.data.shop_record
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'warning-row';
      }
      return '';
    },
    async queryOrder() {
      let res = await this.$http.queryOrder(this.order)
      this.orderInfo = res.data.data
    }
  }
}
</script>
<style lang="less" scoped>
.clothingInquiries {
  margin: 0 10px;
  .el-input {
    width: auto;
  }
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
</style>